import { Get_User_Settings } from "@/modules/crm/leads/graphql-queries";
import Lead_signalr from "@/modules/crm/leads/signalr-constants";
import { jsonParser } from "@/services/generic.methods";
import UseGql from "@/services/graph-ql/useGql";
import OnInitHub from "@/services/signal-R/on-receive-hook";
import useSignalRClient from "@/services/signal-R/signalr-hubs";
import { getLoggedinUser } from "@/store/slices/auth/authSlice";
import { getAllRequests } from "@/store/slices/requests";
import guid from "guid";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useUserSettings = () => {
  const [settings, setSettings] = useState(null);
  const [fetched, setFetched] = useState(false);
  const [requestPending, setRequestPending] = useState(false);
  const { loading, executeQuery } = UseGql(Get_User_Settings);
  const user = useSelector(getLoggedinUser);
  const requests = useSelector(getAllRequests);

  const { clearStateByMethods } = OnInitHub();
  const {
    hubName,
    InvokeMethodNames: { createUserSettings },
    onReceiveMethodNames: { onCreateUserSettings },
  } = Lead_signalr;
  const { statuses, RTC } = useSignalRClient({ hubName: hubName });
  const leadhub = RTC[hubName];
  const leadhubStatus = statuses[hubName];
  const getUserSettings = (key = "") => {
    let where = { and: [] };

    if (key) {
      where.and.push({ key: { eq: key } });
    }
    return executeQuery({
      order: [{ id: "DESC" }],
      where,
      userId: user?.UserID,
    })
      .then((res) => {
        const { data } = res;
        console.log(data, "response");
        if (data && data?.userSetting) {
          let temp = data?.userSetting.items[0];
          if (temp) {
            setSettings({
              ...temp,
              value: jsonParser(temp.value),
            });
          }
          setTimeout(() => {
            setFetched(true);
          }, 200);
        }
      })
      .catch((err) => console.log("onError", err));
  };

  useEffect(() => {
    if (requests[onCreateUserSettings]) {
      let responseData = requests[onCreateUserSettings];
      console.log(responseData, "user settings listener called");
      setRequestPending(false);
      if (responseData?.isSuccess) {
      } else {
      }

      clearStateByMethods([onCreateUserSettings]);
    }
  }, [requests[onCreateUserSettings]]);

  const addUserSettings = (key, value) => {
    let payload = {
      userSetting: {
        ...(settings || {}),
        key: key,
        value: JSON.stringify(value),
        userId: user?.UserID,
        clientType: 1,
      },
      requestId: guid.raw(),
    };

    console.log(payload);
    if (statuses[hubName] && leadhub) {
      setRequestPending(true);
      leadhub.invoke(createUserSettings, payload).then((res) => {
        console.log("user setting request", payload);
      });
    }
  };

  return {
    settings,
    settingsLoading: loading,
    fetched,
    getUserSettings,
    addUserSettings,
    requestPending,
  };
};

export default useUserSettings;

export const SettingsKey = {
  new_feature: "new_feature",
  quick_stats: "quick_stats",
  dashboard_default: "dashboard_default",
  user_theme: "usertheme",
};
